module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.closeTransition ? '' : 'el-zoom-in-center'
    }
  }, [_c('span', {
    staticClass: "vm-tag",
    class: [_vm.type ? 'vm-tag--' + _vm.type : '', {
      'hit': _vm.hit
    }, _vm.tagclass],
    style: ({
      backgroundColor: _vm.color
    })
  }, [_vm._t("default"), _vm._v(" "), (_vm.closable) ? _c('i', {
    staticClass: "vm-tag__close vm-tag-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6de353af", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de353af","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag.vue
// module id = 17
// module chunks = 0